import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';

function RegisterCommunityModal(props) {
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate('/');
    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="register-community-modal"
            className='register-community-modal'
            centered
        >
            <Modal.Header>
                <Modal.Title id="register-community-modal">
                    Thank you! Your application has been successfully submitted.
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='text mb-4'>
                    Your registration has been successfully submitted and is now <span>pending approval</span> from the portal administrator. Our team will review your application to ensure that all necessary information is provided.
                </div>
                <div className='text mb-4'>
                    You will receive an email notification once your community is approved. This process may take up to 2 business days.
                </div>
                <div className='text mb-4'>
                    If your registration is approved, you will receive login credentials that will allow you to access your community dashboard and manage applications.
                </div>
                <div className='text mb-4'>
                    If you have any questions or need further assistance, please feel free to contact our support team at support@buildingpermitportal.com.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button id='backToHome-registerCommunity' className='backToHome text-uppercase' onClick={handleGoBack}>Go Back to homepage</Button>
            </Modal.Footer>
        </Modal>
    );
}


export default RegisterCommunityModal;